import { useState } from 'react';
import { Form, Button, Modal, Alert } from 'react-bootstrap';
import axios from 'axios';
import './Contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [showModal, setShowModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false); 

    // Determine backend API base URL
    const API_BASE_URL = process.env.NODE_ENV === "production"
        ? "https://www.freightopstms.com/tms/api/contact"
        : "http://localhost:5000/tms/api/contact";

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setErrorMessage('');
        console.log("🚀 Submit button clicked!");

        try {
            console.log("📡 Sending request to:", API_BASE_URL);
            console.log("📨 Data being sent:", formData);

            const response = await axios.post(API_BASE_URL, formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            console.log("✅ Response received:", response);

            if (response.status === 200) {
                setShowModal(true);
                setFormData({ name: '', email: '', message: '' });
                console.log("🎉 Message sent successfully!");
            }
        } catch (error) {
            console.error("❌ Error sending message:", error);
            setErrorMessage("Failed to send message. Please try again later.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <article className="contact-webapp-page">
            <h1>Contact Us</h1>

            <div className="contact-webapp-main">
                <section className="contact-webapp-description">
                    <p>Questions or concerns?</p>
                    <p>Send us a message, and our team will be in touch.</p>
                </section>
    
                <section className="contact-webapp-form-container">
                    {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
    
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formMessage" className="contact-webapp-form-group">
                            <Form.Label className="sr-only">Message</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={11} 
                                placeholder="Enter your message" 
                                name="message" 
                                value={formData.message} 
                                onChange={handleChange} 
                                required
                            />
                        </Form.Group>
    
                        <Button 
                            variant="primary" 
                            type="submit" 
                            className="contact-webapp-submit-button" 
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Sending..." : "Submit"}
                        </Button>
                    </Form>
    
                    {/* Success Modal */}
                    <Modal show={showModal} onHide={() => setShowModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Success</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Message sent successfully!
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={() => setShowModal(false)}>
                                OK
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </section>
            </div>
        </article>
    );
};

export default Contact;
